import { toaster } from '@/components/ui/toaster';
import axiosInstance from '@/libs/axiosInstance';
import type { ConsentRecord } from '@fluenceur/types';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

interface AcceptLegalResponse {
  success: boolean;
  message: string;
  data: {
    consents: ConsentRecord[];
  };
}

interface AcceptLegalDto {
  legalAccepted: boolean;
  documents?: Array<{ type: 'cgu' | 'privacy' | 'cgv'; version: string }>;
}

export const useAcceptLegalAction = () => {
  const { t } = useTranslation();

  return useMutation<AcceptLegalResponse, Error, AcceptLegalDto>({
    mutationFn: async (data: AcceptLegalDto): Promise<AcceptLegalResponse> => {
      const response = await axiosInstance.post<AcceptLegalResponse>(
        '/dashboard/legal-acceptance',
        data
      );
      return response.data;
    },
    onError: (error: Error) => {
      console.error('Failed to accept legal documents:', error);

      toaster.error({
        title: t('common.error'),
        description: t('onboarding.legal.errorMessage'),
      });
    },
  });
};
